import React, { useState, useEffect } from 'react';
import InventoryEntriesList from './InventoryEntriesList';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import NeatixModal from '@components/Modal/NeatixModal';
import AddEntries from '../InventoryCountEntries/AddEntries';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getEnteriesListByInventoryCountId } from '@store/INV/InventoryCount/inventoryCountSlice';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

// const InventoryEntries: React.FC = () => {
//   const [showModal, setShowModal] = useState<boolean>(false);
//   const dispatch = useAppDispatch();
//   const { invCountId } = useParams();

//   const { EnteriesList: entries, loading } = useAppSelector(a => a.InventoryCount);

//   // جلب البيانات
//   useEffect(() => {
//     if (invCountId) {
//       dispatch(getEnteriesListByInventoryCountId(invCountId));
//     }
//   }, [invCountId, dispatch]);

//   const handleOpenModal = (): void => {
//     setShowModal(true);
//   };

//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             {
//               name: 'Home',
//              link: ':moduleHome'
//             },
//             {
//               name: 'جرد المخزون',
//               link: ''
//             },
//             {
//               name: 'إدخالات جرد المخزون',
//               link: null
//             }
//           ]}
//         />
//       </div>

//       <Card className='mb-4'>
//         <CardBody>
//           <div className='d-flex justify-content-between align-items-center '>
//             <h4 className='mb-0 text-theme'>إدخالات جرد المخزون</h4>
//             <button className='btn btn-sm btn-theme' onClick={handleOpenModal} disabled={loading}>
//               <i className='fas fa-plus me-2'></i>
//               إدخال جديد
//             </button>
//           </div>
//         </CardBody>
//       </Card>

//       <CardBody>
//         <div className='row'>
//           <div className='col-12'>
//             <InventoryEntriesList entries={entries} loading={loading} />
//           </div>
//         </div>
//       </CardBody>

//       <NeatixModal show={showModal} setShow={setShowModal} title='' size={'xl'}>
//         <AddEntries />
//       </NeatixModal>
//     </>
//   );
// };

const InventoryEntries: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const { invCountId } = useParams();
  const navigate = useNavigate();

  const { EnteriesList: entries, loading, error } = useAppSelector(a => a.InventoryCount);

  // جلب البيانات
  useEffect(() => {
    if (invCountId) {
      dispatch(getEnteriesListByInventoryCountId(invCountId));
    }
  }, [invCountId, dispatch]);

  const handleOpenModal = (): void => {
    setShowModal(true);
  };

  const handleGoBack = (): void => {
    navigate(-1);
  };

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: 'جرد المخزون',
              link: ''
            },
            {
              name: 'إدخالات جرد المخزون',
              link: null
            }
          ]}
        />
      </div>

      <Card className='mb-4'>
        <CardBody>
          <div className='d-flex justify-content-between align-items-center'>
            {/* العنوان مع الأيقونة */}
            <div className='d-flex align-items-center'>
              <i className='fas fa-clipboard-list text-theme fs-2 me-3'></i>
              <div>
                <h4 className='mb-0 text-theme'>إدخالات جرد المخزون</h4>
                <small className='text-muted'>أســـم ووصف الجـرد</small>
              </div>
            </div>

            {/* مجموعة الأزرار */}
            <div className='d-flex gap-2'>
              {/* زر الرجوع */}
              <button
                className='btn btn-sm btn-outline-secondary d-flex align-items-center'
                onClick={handleGoBack}
                title='الرجوع للخلف'
              >
                <i className='fas fa-arrow-right me-1'></i>
                رجوع
              </button>

              {/* زر الإضافة */}
              <button
                className='btn btn-sm btn-theme d-flex align-items-center'
                onClick={handleOpenModal}
                disabled={loading}
              >
                <i className='fas fa-plus me-1'></i>
                إدخال جديد
              </button>
            </div>
          </div>
        </CardBody>
      </Card>

      <CardBody>
        <div className='row'>
          <div className='col-12'>
            <InventoryEntriesList entries={entries} loading={loading} error={error} />
          </div>
        </div>
      </CardBody>

      <NeatixModal show={showModal} setShow={setShowModal} size={'xl'} showHeader={false} bodyClassName='p-0' backdrop>
        <AddEntries onClose={() => setShowModal(false)} />
      </NeatixModal>
    </>
  );
};

export default InventoryEntries;
